import * as React from "react";

interface MinusCircleIconProps {
    className?: string;
    onClick?: () => void;
    size?: number;
    color?: string;
}

export function MinusCircleIcon({ size = 32, color = "currentColor", ...props }: MinusCircleIconProps) {
    return (
        <div {...props}>
            <svg
                width={size}
                height={size}
                viewBox="0 0 512 512"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 232H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
                    fill={color}
                />
            </svg>
        </div>
    );
}
